export const NETBANKING_PAYMENT_METHOD_CODE = "NB";
